import { Announcement } from './Announcement';
import type { ClientSession } from '../api';
import { Brand } from './Brand';
import { api } from '../api';

export function Shell({
  session,
  children,
  onCookieInfo,
}: {
  session: ClientSession | null;
  children: React.ReactNode;
  onCookieInfo: () => void;
}) {
  const logout = async () => {
    sessionStorage.removeItem('branding-preview');
    if (session?.capabilities.local) await api.localLogout();
    else {
      const { authClient } = await import('../auth-client');
      await authClient.signOut();
    }
    window.location.assign('/');
  };
  return (
    <div className="site-shell">
      <header className="site-header">
        <Brand />
        <nav aria-label="Account">
          {session?.user ? (
            <div className="account-actions">
              {session.user.role === 'admin' && (
                <a className="admin-entry" href="/admin">
                  Admin
                </a>
              )}
              <a
                className="account-chip"
                href={
                  session.capabilities.staff || session.capabilities.parentInvites
                    ? '/account'
                    : '/settings'
                }
              >
                <span aria-hidden="true">{session.user.name.slice(0, 1).toUpperCase()}</span>
                {session.user.name}
              </a>
              <button className="link-button" onClick={() => void logout()}>
                Sign out
              </button>
            </div>
          ) : (
            <a className="text-link" href="/login">
              Sign in
            </a>
          )}
        </nav>
      </header>
      <Announcement />
      {children}
      <footer className="site-footer">
        <p>Made for our school community.</p>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms of Use</a>
        {session?.capabilities.participation && <a href="/participation">Polls &amp; feedback</a>}
        <button className="link-button" onClick={onCookieInfo}>
          Cookie details
        </button>
      </footer>
    </div>
  );
}
